export default __webpack_public_path__ + "static/media/AoI.4d73abe8.svg";